
export const returnTrue = (a: any, b: any) => {
   if(a){
     return a
   }
   return b
};
